import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'tailwindcss/tailwind.css';
import "../../../../App.css"

const RegistroExitosoPage = () => {

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-black relative"
      style={{
        backgroundImage: 'url(https://i.postimg.cc/rw3XpzPP/wallpaper.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Overlay para asegurar que cubra toda la página */}
      <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-black bg-opacity-50"></div>
      
      <div className="z-10 max-w-md w-full">
        <div className="text-center mb-8">
          <h2 className="mt-6 text-4xl font-extrabold text-white">
            ¡Registro Exitoso!
          </h2>
          <p className="mt-2 text-sm text-gray-300">
            Estás a un paso de unirte a nuestra comunidad
          </p>
        </div>
        
        <div className="bg-zinc-900 rounded-2xl shadow-xl overflow-hidden">
          <div className="p-8">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <svg className="h-10 w-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-2">Usuario creado exitosamente</h3>
              <p className="text-gray-400 mb-6">
                Por favor verifica tu correo electrónico 
                para activar tu cuenta.
              </p>
              
              <div className="bg-yellow-500/10 border border-yellow-400 text-yellow-100 px-4 py-3 rounded mb-6">
                <p className="text-sm">Si no recibes el correo en unos minutos, revisa tu carpeta de spam o correo no deseado.</p>
              </div>
              
              <Link to="/login"
                className="inline-block w-full py-3 px-4 border border-transparent rounded-lg
                        text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                        focus:ring-red-500 font-bold transition duration-300"
              >
                Ir a iniciar sesión
              </Link>
            </div>
          </div>
          
          <div className="px-8 py-6 bg-zinc-950 text-center">
            <p className="text-gray-300">
              ¿No recibiste el correo? <Link to="/soporte" className="text-red-400 hover:underline font-bold">Contactar soporte</Link>
            </p>
            <p className="text-xs text-gray-500 mt-4">
              Gracias por unirte a nuestra comunidad. Si tienes alguna pregunta o necesitas ayuda, no dudes en contactar a nuestro equipo de soporte.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistroExitosoPage;